import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { GlitchLogEntry } from '../types/glitch-log-entry';

@Component({
  selector: 'glitches',
  templateUrl: './glitches.component.html',
  styleUrls: ['./glitches.component.css'],
  providers: [HubService],
})

export class GlitchesComponent implements OnInit {
  glitches: GlitchLogEntry[];
  hubID: number;
  private fromTimestamps: string[] = <string[]>[];
  errorMessage: string;

  static handleRefreshError(err: any): void {
    if (err.status !== 401) {
      console.log('GlitchesComponent Error: ' + err);
    }
  }

  constructor(
    private hubService: HubService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    document.getElementById('title').innerText = 'All Glitches';
    this.route.params.pipe(
      switchMap((params: Params) => this.switchedHub(params['hubid']))
    ).subscribe();
  }

  switchedHub(hubID: number): Observable<number> {
    console.log('Switched HUB: ' + hubID);
    this.hubID = hubID;
    this.fromTimestamps = <string[]>[];
    this.later();
    return of(this.hubID);
  }

  newGlitchLogs(glitches: GlitchLogEntry[]): void {
    let updated = <GlitchLogEntry[]>[];
    for (let g of glitches) {
      updated.push(g);
      console.log(g.created + ': ' + g.hubid + ' - ' + g.payload.information);
    }
    this.glitches = updated;
  }

  earlier(): void {
    let created: string = null;
    try {
      created = this.glitches[this.glitches.length - 1].created;
      if (!this.fromTimestamps) {
        this.fromTimestamps = <string[]>[];
      }
      this.fromTimestamps.push(this.glitches[0].created);
    } catch (err) {
      console.log(err);
    }
    this.hubService.getGlitchLogs(+this.hubID, created)
      .subscribe(
        (values: GlitchLogEntry[]) => this.newGlitchLogs(values),
        (err: any) => GlitchesComponent.handleRefreshError(err)
      );
  }

  later(): void {
    let created: string = null;
    if (this.fromTimestamps.length > 0) {
      try {
        created = this.fromTimestamps[this.fromTimestamps.length - 1];
        this.fromTimestamps = this.fromTimestamps.slice(0, -1);
      } catch (err) {
        console.log(err);
      }
    }
    this.hubService.getGlitchLogs(+this.hubID, created)
      .subscribe(
        (values: GlitchLogEntry[]) => this.newGlitchLogs(values),
        (err: any) => GlitchesComponent.handleRefreshError(err)
      );
  }

  gotoDetail(glitch: GlitchLogEntry): void {
    this.router.navigate(['/hub', glitch.hubid]);
  }

}

